import React from "react";

const Category2 = ({ id, dndProps }) => {
  return <div {...dndProps}>Category2</div>;
};

export default Category2;
